import { render, staticRenderFns } from "./UserFollow.vue?vue&type=template&id=2dba19b4&scoped=true&"
import script from "./UserFollow.vue?vue&type=script&lang=js&"
export * from "./UserFollow.vue?vue&type=script&lang=js&"
import style0 from "./UserFollow.vue?vue&type=style&index=0&id=2dba19b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dba19b4",
  null
  
)

export default component.exports